module.exports = __webpack_public_path__ + "img/cross2.85790110.svg";